export default __webpack_public_path__ + "static/media/030_corner1.vp8.46d3f4fe.webm";